<!-- po0100 ログイン -->
<template>
    <v-app :style="{ background: $vuetify.theme.themes.light.background }">
        <v-main>
            <v-container fill-height>
                <v-row justify="center">
                    <v-col class="ma-3"
                           sm="6" md="6" lg="4" xl="4">
                        <v-card elevation="5">
                            <v-toolbar color="primary"
                                       class="text-h6 white--text"
                                       flat>
                                搬入出依頼受付システム
                            </v-toolbar>
                            <v-card-text>
                                <v-alert class="text-body-2"
                                         type="error"
                                         v-if="errMessage != ''"
                                         dense>
                                    {{ errMessage }}
                                </v-alert>
                                <v-form ref="form"
                                        lazy-validation>
                                    <v-text-field class="text-body-1"
                                                  label="ID"
                                                  prepend-inner-icon="account_box"
                                                  v-model="user.user_cd"
                                                  :rules="[rules.user_cd]"
                                                  validate-on-blur>
                                    </v-text-field>
                                    <v-text-field class="text-body-1"
                                                  type="password"
                                                  label="PASSWORD"
                                                  prepend-inner-icon="vpn_key"
                                                  v-model="user.password"
                                                  :rules="[rules.password]"
                                                  validate-on-blur>
                                    </v-text-field>
                                    <v-btn color="primary"
                                           class="text-body-1"
                                           :disabled="isDisabled"
                                           large
                                           block
                                           @click="login">
                                        Login
                                    </v-btn>
                                </v-form>
                            </v-card-text>
                            <v-card-text class="pa-2 pt-0 text-subtitle-2 text-right"
                                         v-if="appVersion != ''">
                                {{ appVersion }}
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
    export default {
        mounted() {
            this.$nextTick(() => {
            });
        },
        data() {
            return {
                appVersion: g_version,
                errMessage: g_errmessage,
                user: {
                    user_cd: '',
                    password: '',
                },
                rules: {
                    user_cd: (v) => !!v || 'IDを入力してください',
                    password: (v) => !!v || 'パスワードを入力してください',
                },
                isDisabled: false,
            };
        },
        methods: {
            login() {
                if (this.$refs.form.validate()) {
                    this.isDisabled = true;
                    this.errMessage = '';

                    const params = new URLSearchParams();
                    params.append('param', JSON.stringify(this.user));

                    this.axios_post('/po0100/CheckLogin', params).then((res) => {
                        if (res.data.status === 'OK') {
                            window.location.href = '/po0200/index';
                        } else {
                            this.errMessage = res.data.errMessage;
                        }
                    }).catch((err) => {
                        this.msg_error_dialog(err);
                    }).finally(() => {
                        this.isDisabled = false;
                    });
                }
            },
        },
    };
</script>
